module.exports = __webpack_public_path__ + "img/AFRICA_RED_MEATS.1af42ace.png";